import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { useSubscription } from '@/context/SubscriptionContext';
import { auth } from '@/firebase';
import { BILLING_OFFER_ID_PRO_TRIAL, BILLING_OFFER_ID_PERSONAL_TRIAL } from '@/services/billingService';

export function FreeBanner({ onOpenPlanModal }) {
  const { isFree, cachedProducts, isPlanReady } = useSubscription();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isFree === undefined) return;
    if (!isPlanReady) return; // No mostrar banner mientras se resuelve el plan
    
    const uid = auth.currentUser?.uid;
    if (!uid) {
      setVisible(false);
      return;
    }

    const storageKey = `rutapp_welcome_choice_done_${uid}`;
    const welcomeDone = localStorage.getItem(storageKey) === 'true';
    setVisible(isFree && welcomeDone);
  }, [isFree, isPlanReady]);

  if (!visible) return null;

  // Fallback seguro si cachedProducts es undefined
  const products = Array.isArray(cachedProducts) ? cachedProducts : [];
  const hasFreeTrialOffer = products.some(
    p => p.offerId === BILLING_OFFER_ID_PRO_TRIAL || p.offerId === BILLING_OFFER_ID_PERSONAL_TRIAL
  );

  return (
    <div
      className="fixed left-3 right-3 z-40 bg-primary rounded-2xl shadow-lg px-4 py-3 flex items-center gap-3"
      style={{ bottom: 'calc(env(safe-area-inset-bottom) + 8px)' }}
    >
      <p className="flex-1 text-sm text-white leading-snug">
        <span className="font-semibold">Modo Free</span>
        <span className="ml-1 opacity-90">
          {hasFreeTrialOffer ? '· Prueba Premium 1 mes gratis' : '· Mejora a Premium'}
        </span>
      </p>
      <button
        onClick={onOpenPlanModal}
        className="flex-shrink-0 bg-white text-primary text-sm font-semibold rounded-xl px-3 py-1.5 hover:bg-white/90 transition-colors"
      >
        Ver planes
      </button>
    </div>
  );
}
